// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-us-container {
  font-family: "Open Sans", sans-serif;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: calc(100vh - 64px);
  padding: 2rem 1rem;
  background-color: #f5f5f5;
}
.contact-us-container .contact-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 700px;
  width: 100%;
}
.contact-us-container .contact-card .contact-header {
  margin-bottom: 2rem;
  text-align: center;
}
.contact-us-container .contact-card .contact-header h1 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin: 0 0 0.5rem 0;
  font-size: 2rem;
  font-weight: 500;
  color: #212121;
}
.contact-us-container .contact-card .contact-header h1 mat-icon {
  font-size: 2rem;
  width: 2rem;
  height: 2rem;
  color: #1976d2;
}
.contact-us-container .contact-card .contact-header .subtitle {
  color: #666;
  font-size: 0.95rem;
  margin: 0;
}
.contact-us-container .contact-card .form-section {
  margin-bottom: 1.5rem;
}
.contact-us-container .contact-card .form-section label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #424242;
  font-size: 1rem;
}
.contact-us-container .contact-card .form-section label mat-icon {
  font-size: 1.2rem;
  width: 1.2rem;
  height: 1.2rem;
  color: #666;
}
.contact-us-container .contact-card .form-section label.required::after {
  content: " *";
  color: #d32f2f;
}
.contact-us-container .contact-card .form-section .full-width {
  width: 100%;
}
.contact-us-container .contact-card .form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e0e0e0;
}
.contact-us-container .contact-card .form-actions .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 18px;
  border: none;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: none;
  letter-spacing: 0;
  min-width: 120px;
}
.contact-us-container .contact-card .form-actions .btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.contact-us-container .contact-card .form-actions .btn .inline-spinner {
  display: inline-block;
  margin-right: 0.5rem;
}
.contact-us-container .contact-card .form-actions .btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.contact-us-container .contact-card .form-actions .btn-primary {
  background: #065fd4;
  color: #fff;
}
.contact-us-container .contact-card .form-actions .btn-primary:hover:not(:disabled) {
  background: #0d47a1;
}
.contact-us-container .contact-card .form-actions .btn-primary:disabled {
  background: #e0e0e0;
  color: #909090;
}
.contact-us-container .contact-card .form-actions .btn-secondary {
  background: transparent;
  color: #065fd4;
  border: 1px solid #065fd4;
}
.contact-us-container .contact-card .form-actions .btn-secondary:hover:not(:disabled) {
  background: #f0f7ff;
}
.contact-us-container .contact-card .form-actions .btn-secondary:disabled {
  border-color: #e0e0e0;
  color: #909090;
}

@media (max-width: 768px) {
  .contact-us-container {
    padding: 1rem 0.5rem;
  }
  .contact-us-container .contact-card {
    padding: 1.5rem;
  }
  .contact-us-container .contact-card .contact-header h1 {
    font-size: 1.5rem;
  }
  .contact-us-container .contact-card .form-actions {
    flex-direction: column-reverse;
  }
  .contact-us-container .contact-card .form-actions .btn {
    width: 100%;
  }
}
::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {
  color: #bdbdbd;
}
::ng-deep .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {
  color: #1976d2;
}
::ng-deep .mat-form-field-invalid .mat-form-field-outline-thick {
  color: #d32f2f !important;
}

/* -------------------------------------------------------------------------- */
/* Dark mode: page + card + fields (aligns with app body.theme-dark shell)   */
/* -------------------------------------------------------------------------- */
:host-context(body.theme-dark) .contact-us-container {
  background-color: #0a0c10;
}
:host-context(body.theme-dark) .contact-card {
  background: #111827;
  border: 1px solid rgba(148, 163, 184, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}
:host-context(body.theme-dark) .contact-header h1 {
  color: #f8fafc;
}
:host-context(body.theme-dark) .contact-header h1 mat-icon {
  color: #5ea1d8;
}
:host-context(body.theme-dark) .contact-header .subtitle {
  color: #94a3b8;
}
:host-context(body.theme-dark) .form-section label {
  color: #e2e8f0;
}
:host-context(body.theme-dark) .form-section label mat-icon {
  color: #94a3b8;
}
:host-context(body.theme-dark) .form-section label.required::after {
  color: #f87171;
}
:host-context(body.theme-dark) .form-actions {
  border-top-color: rgba(148, 163, 184, 0.22);
}
:host-context(body.theme-dark) .form-actions .btn-primary {
  background: #5ea1d8;
  color: #fff;
}
:host-context(body.theme-dark) .form-actions .btn-primary:hover:not(:disabled) {
  background: #4a8fc4;
}
:host-context(body.theme-dark) .form-actions .btn-primary:disabled {
  background: #1f2937;
  color: #64748b;
}
:host-context(body.theme-dark) .form-actions .btn-secondary {
  color: #93c5fd;
  border-color: #5ea1d8;
}
:host-context(body.theme-dark) .form-actions .btn-secondary:hover:not(:disabled) {
  background: rgba(94, 161, 216, 0.12);
}
:host-context(body.theme-dark) .form-actions .btn-secondary:disabled {
  border-color: #334155;
  color: #64748b;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field {
  --mdc-outlined-text-field-container-shape: 4px;
  --mdc-outlined-text-field-label-text-color: #94a3b8;
  --mdc-outlined-text-field-input-text-color: #e2e8f0;
  --mdc-outlined-text-field-caret-color: #5ea1d8;
  --mdc-outlined-text-field-focus-label-text-color: #5ea1d8;
  --mdc-outlined-text-field-hover-label-text-color: #cbd5e1;
  --mdc-outlined-text-field-disabled-label-text-color: #64748b;
  --mdc-outlined-text-field-outline-color: rgba(148, 163, 184, 0.35);
  --mdc-outlined-text-field-hover-outline-color: rgba(148, 163, 184, 0.5);
  --mdc-outlined-text-field-focus-outline-color: #5ea1d8;
}
:host-context(body.theme-dark) ::ng-deep .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline .mdc-notched-outline__leading,
:host-context(body.theme-dark) ::ng-deep .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline .mdc-notched-outline__notch,
:host-context(body.theme-dark) ::ng-deep .mdc-text-field--outlined:not(.mdc-text-field--disabled) .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: rgba(148, 163, 184, 0.35);
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field.mat-focused .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field.mat-focused .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__notch,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field.mat-focused .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: #5ea1d8;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field.mat-form-field-invalid .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__leading,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field.mat-form-field-invalid .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__notch,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field.mat-form-field-invalid .mdc-text-field--outlined .mdc-notched-outline .mdc-notched-outline__trailing {
  border-color: #f87171 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-input-element,
:host-context(body.theme-dark) ::ng-deep textarea.mat-mdc-input-element {
  caret-color: #5ea1d8;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-input-element::placeholder {
  color: #64748b;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field-hint,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-hint {
  color: #94a3b8;
}
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field-error,
:host-context(body.theme-dark) ::ng-deep .mat-mdc-form-field .mat-mdc-form-field-error {
  color: #f87171 !important;
}
:host-context(body.theme-dark) ::ng-deep .mdc-floating-label--float-above {
  color: #5ea1d8 !important;
}
:host-context(body.theme-dark) ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {
  color: rgba(148, 163, 184, 0.4);
}
:host-context(body.theme-dark) ::ng-deep .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {
  color: #5ea1d8;
}
:host-context(body.theme-dark) ::ng-deep .mat-form-field-invalid .mat-form-field-outline-thick {
  color: #f87171 !important;
}

.hp-field {
  position: absolute;
  left: -10000px;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/contact-us/contact-us.component.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,yBAAA;AACF;AACE;EACE,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AACJ;AACI;EACE,mBAAA;EACA,kBAAA;AACN;AACM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACR;AACQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AACV;AAGM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;AADR;AAKI;EACE,qBAAA;AAHN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAHR;AAKQ;EACE,iBAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;AAHV;AAMQ;EACE,aAAA;EACA,cAAA;AAJV;AAQM;EACE,WAAA;AANR;AAUI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AARN;AAUM;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;AARR;AAUQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AARV;AAWQ;EACE,qBAAA;EACA,oBAAA;AATV;AAYQ;EACE,mBAAA;EACA,YAAA;AAVV;AAcM;EACE,mBAAA;EACA,WAAA;AAZR;AAcQ;EACE,mBAAA;AAZV;AAeQ;EACE,mBAAA;EACA,cAAA;AAbV;AAiBM;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;AAfR;AAiBQ;EACE,mBAAA;AAfV;AAkBQ;EACE,qBAAA;EACA,cAAA;AAhBV;;AAwBA;EACE;IACE,oBAAA;EArBF;EAuBE;IACE,eAAA;EArBJ;EAuBI;IACE,iBAAA;EArBN;EAwBI;IACE,8BAAA;EAtBN;EAwBM;IACE,WAAA;EAtBR;AACF;AA+BI;EACE,cAAA;AA7BN;AAgCI;EACE,cAAA;AA9BN;AAmCI;EACE,yBAAA;AAjCN;;AAsCA,+EAAA;AACA,8EAAA;AACA,+EAAA;AAEE;EACE,yBAAA;AApCJ;AAuCE;EACE,mBAAA;EACA,0CAAA;EACA,yCAAA;AArCJ;AAyCI;EACE,cAAA;AAvCN;AAyCM;EACE,cAAA;AAvCR;AA2CI;EACE,cAAA;AAzCN;AA8CI;EACE,cAAA;AA5CN;AA8CM;EACE,cAAA;AA5CR;AA+CM;EACE,cAAA;AA7CR;AAkDE;EACE,2CAAA;AAhDJ;AAkDI;EACE,mBAAA;EACA,WAAA;AAhDN;AAkDM;EACE,mBAAA;AAhDR;AAmDM;EACE,mBAAA;EACA,cAAA;AAjDR;AAqDI;EACE,cAAA;EACA,qBAAA;AAnDN;AAqDM;EACE,oCAAA;AAnDR;AAsDM;EACE,qBAAA;EACA,cAAA;AApDR;AA2DI;EACE,8CAAA;EACA,mDAAA;EACA,mDAAA;EACA,8CAAA;EACA,yDAAA;EACA,yDAAA;EACA,4DAAA;EACA,kEAAA;EACA,uEAAA;EACA,sDAAA;AAzDN;AA4DI;;;EASE,uCAAA;AAhEN;AAmEI;;;EAYE,qBAAA;AA1EN;AA6EI;;;EAYE,gCAAA;AApFN;AAuFI;;EAEE,oBAAA;AArFN;AAwFI;EACE,cAAA;AAtFN;AAyFI;;EAEE,cAAA;AAvFN;AA0FI;;EAEE,yBAAA;AAxFN;AA2FI;EACE,yBAAA;AAzFN;AA8FM;EACE,+BAAA;AA5FR;AA+FM;EACE,cAAA;AA7FR;AAiGI;EACE,yBAAA;AA/FN;;AAoGA;EACE,kBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;AAjGF","sourcesContent":[".contact-us-container {\n  font-family: \"Open Sans\", sans-serif;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: calc(100vh - 64px);\n  padding: 2rem 1rem;\n  background-color: #f5f5f5;\n\n  .contact-card {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    padding: 2rem;\n    max-width: 700px;\n    width: 100%;\n\n    .contact-header {\n      margin-bottom: 2rem;\n      text-align: center;\n\n      h1 {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n        margin: 0 0 0.5rem 0;\n        font-size: 2rem;\n        font-weight: 500;\n        color: #212121;\n\n        mat-icon {\n          font-size: 2rem;\n          width: 2rem;\n          height: 2rem;\n          color: #1976d2;\n        }\n      }\n\n      .subtitle {\n        color: #666;\n        font-size: 0.95rem;\n        margin: 0;\n      }\n    }\n\n    .form-section {\n      margin-bottom: 1.5rem;\n\n      label {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        margin-bottom: 0.5rem;\n        font-weight: 500;\n        color: #424242;\n        font-size: 1.0rem;\n\n        mat-icon {\n          font-size: 1.2rem;\n          width: 1.2rem;\n          height: 1.2rem;\n          color: #666;\n        }\n\n        &.required::after {\n          content: \" *\";\n          color: #d32f2f;\n        }\n      }\n\n      .full-width {\n        width: 100%;\n      }\n    }\n\n    .form-actions {\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      gap: 1rem;\n      margin-top: 2rem;\n      padding-top: 1.5rem;\n      border-top: 1px solid #e0e0e0;\n\n      .btn {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n        padding: 10px 24px;\n        font-size: 14px;\n        font-weight: 500;\n        border-radius: 18px;\n        border: none;\n        cursor: pointer;\n        transition: all 0.2s;\n        text-transform: none;\n        letter-spacing: 0;\n        min-width: 120px;\n\n        mat-icon {\n          font-size: 20px;\n          width: 20px;\n          height: 20px;\n        }\n\n        .inline-spinner {\n          display: inline-block;\n          margin-right: 0.5rem;\n        }\n\n        &:disabled {\n          cursor: not-allowed;\n          opacity: 0.6;\n        }\n      }\n\n      .btn-primary {\n        background: #065fd4;\n        color: #fff;\n\n        &:hover:not(:disabled) {\n          background: #0d47a1;\n        }\n\n        &:disabled {\n          background: #e0e0e0;\n          color: #909090;\n        }\n      }\n\n      .btn-secondary {\n        background: transparent;\n        color: #065fd4;\n        border: 1px solid #065fd4;\n\n        &:hover:not(:disabled) {\n          background: #f0f7ff;\n        }\n\n        &:disabled {\n          border-color: #e0e0e0;\n          color: #909090;\n        }\n      }\n    }\n  }\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .contact-us-container {\n    padding: 1rem 0.5rem;\n\n    .contact-card {\n      padding: 1.5rem;\n\n      .contact-header h1 {\n        font-size: 1.5rem;\n      }\n\n      .form-actions {\n        flex-direction: column-reverse;\n\n        .btn {\n          width: 100%;\n        }\n      }\n    }\n  }\n}\n\n// Material form field customizations (light theme)\n::ng-deep {\n  .mat-form-field-appearance-outline {\n    .mat-form-field-outline {\n      color: #bdbdbd;\n    }\n\n    &.mat-focused .mat-form-field-outline-thick {\n      color: #1976d2;\n    }\n  }\n\n  .mat-form-field-invalid {\n    .mat-form-field-outline-thick {\n      color: #d32f2f !important;\n    }\n  }\n}\n\n/* -------------------------------------------------------------------------- */\n/* Dark mode: page + card + fields (aligns with app body.theme-dark shell)   */\n/* -------------------------------------------------------------------------- */\n:host-context(body.theme-dark) {\n  .contact-us-container {\n    background-color: #0a0c10;\n  }\n\n  .contact-card {\n    background: #111827;\n    border: 1px solid rgba(148, 163, 184, 0.2);\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);\n  }\n\n  .contact-header {\n    h1 {\n      color: #f8fafc;\n\n      mat-icon {\n        color: #5ea1d8;\n      }\n    }\n\n    .subtitle {\n      color: #94a3b8;\n    }\n  }\n\n  .form-section {\n    label {\n      color: #e2e8f0;\n\n      mat-icon {\n        color: #94a3b8;\n      }\n\n      &.required::after {\n        color: #f87171;\n      }\n    }\n  }\n\n  .form-actions {\n    border-top-color: rgba(148, 163, 184, 0.22);\n\n    .btn-primary {\n      background: #5ea1d8;\n      color: #fff;\n\n      &:hover:not(:disabled) {\n        background: #4a8fc4;\n      }\n\n      &:disabled {\n        background: #1f2937;\n        color: #64748b;\n      }\n    }\n\n    .btn-secondary {\n      color: #93c5fd;\n      border-color: #5ea1d8;\n\n      &:hover:not(:disabled) {\n        background: rgba(94, 161, 216, 0.12);\n      }\n\n      &:disabled {\n        border-color: #334155;\n        color: #64748b;\n      }\n    }\n  }\n\n  // MDC / Material 15+ outline fields\n  ::ng-deep {\n    .mat-mdc-form-field {\n      --mdc-outlined-text-field-container-shape: 4px;\n      --mdc-outlined-text-field-label-text-color: #94a3b8;\n      --mdc-outlined-text-field-input-text-color: #e2e8f0;\n      --mdc-outlined-text-field-caret-color: #5ea1d8;\n      --mdc-outlined-text-field-focus-label-text-color: #5ea1d8;\n      --mdc-outlined-text-field-hover-label-text-color: #cbd5e1;\n      --mdc-outlined-text-field-disabled-label-text-color: #64748b;\n      --mdc-outlined-text-field-outline-color: rgba(148, 163, 184, 0.35);\n      --mdc-outlined-text-field-hover-outline-color: rgba(148, 163, 184, 0.5);\n      --mdc-outlined-text-field-focus-outline-color: #5ea1d8;\n    }\n\n    .mdc-text-field--outlined:not(.mdc-text-field--disabled)\n      .mdc-notched-outline\n      .mdc-notched-outline__leading,\n    .mdc-text-field--outlined:not(.mdc-text-field--disabled)\n      .mdc-notched-outline\n      .mdc-notched-outline__notch,\n    .mdc-text-field--outlined:not(.mdc-text-field--disabled)\n      .mdc-notched-outline\n      .mdc-notched-outline__trailing {\n      border-color: rgba(148, 163, 184, 0.35);\n    }\n\n    .mat-mdc-form-field.mat-focused\n      .mdc-text-field--outlined\n      .mdc-notched-outline\n      .mdc-notched-outline__leading,\n    .mat-mdc-form-field.mat-focused\n      .mdc-text-field--outlined\n      .mdc-notched-outline\n      .mdc-notched-outline__notch,\n    .mat-mdc-form-field.mat-focused\n      .mdc-text-field--outlined\n      .mdc-notched-outline\n      .mdc-notched-outline__trailing {\n      border-color: #5ea1d8;\n    }\n\n    .mat-mdc-form-field.mat-form-field-invalid\n      .mdc-text-field--outlined\n      .mdc-notched-outline\n      .mdc-notched-outline__leading,\n    .mat-mdc-form-field.mat-form-field-invalid\n      .mdc-text-field--outlined\n      .mdc-notched-outline\n      .mdc-notched-outline__notch,\n    .mat-mdc-form-field.mat-form-field-invalid\n      .mdc-text-field--outlined\n      .mdc-notched-outline\n      .mdc-notched-outline__trailing {\n      border-color: #f87171 !important;\n    }\n\n    .mat-mdc-input-element,\n    textarea.mat-mdc-input-element {\n      caret-color: #5ea1d8;\n    }\n\n    .mat-mdc-input-element::placeholder {\n      color: #64748b;\n    }\n\n    .mat-mdc-form-field-hint,\n    .mat-mdc-form-field .mat-mdc-form-field-hint {\n      color: #94a3b8;\n    }\n\n    .mat-mdc-form-field-error,\n    .mat-mdc-form-field .mat-mdc-form-field-error {\n      color: #f87171 !important;\n    }\n\n    .mdc-floating-label--float-above {\n      color: #5ea1d8 !important;\n    }\n\n    // Legacy outline appearance (if any)\n    .mat-form-field-appearance-outline {\n      .mat-form-field-outline {\n        color: rgba(148, 163, 184, 0.4);\n      }\n\n      &.mat-focused .mat-form-field-outline-thick {\n        color: #5ea1d8;\n      }\n    }\n\n    .mat-form-field-invalid .mat-form-field-outline-thick {\n      color: #f87171 !important;\n    }\n  }\n}\n\n.hp-field {\n  position: absolute;\n  left: -10000px;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  opacity: 0;\n  pointer-events: none;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
